module.exports = __webpack_public_path__ + "media/images/pic/continuing_number-e997758465d25f9e08d2994e83e0898e.svg";